import fr from "./fr";
import en from "./en";
import es from "./es";
import pt from "./pt";

export const LANGS = ["fr", "en", "es", "pt"];
export const T = { fr, en, es, pt };

export const STRIPE_URL = "https://buy.stripe.com/8x25kDbNC7fggry2VN0sU0b";
export const CALENDLY_URL = "https://calendly.com/r-cassilde/30min";
export const HERO_IMG =
  "https://images.unsplash.com/photo-1741356474357-72188f76e801?crop=entropy&cs=srgb&fm=jpg&q=85";
export const FOUNDER_IMG =
  "https://customer-assets-cm19k8pv.emergentagent.net/wingman/1d54338d-54b8-44b0-9db7-4c0dae9f7fd9/attachments/a14afeff05e64cc9be0dd034fde57cff_rodrigue_photo.jpg";

const A =
  "https://customer-assets-cm19k8pv.emergentagent.net/wingman/1d54338d-54b8-44b0-9db7-4c0dae9f7fd9/attachments";

// Order matches kit.tools: [book, decrees, workbook, grid, map, letter]
export const PDFS = {
  fr: [
    `${A}/72bb329041f54f9c8bb229de9afea1a0_AVANT_QUE_TU_NE_DEVIENNES_v7_FINAL.pdf`,
    `${A}/08a6dac12a6a40e3b48ae94fc8babc89_decrets_souverains.pdf`,
    `${A}/36444a4d182f44eb9fee53f44c408742_carnet_travail_souverain.pdf`,
    `${A}/cc14b98669bf4f92905772369eb84e6a_grille_triple_fusion.pdf`,
    `${A}/aff93e10f3d54cb2bf61f3430a6d391f_carte_directions_loshu.pdf`,
    `${A}/9bec5079b69840dbb5c47c92ac75da87_lettre_du_fondateur.pdf`,
  ],
  en: [
    `${A}/3fcf1a2e115349aa9054e16930bc74bd_BEFORE_YOU_BECOME_EN_v1.pdf`,
    `${A}/c3bc268bb03f45a7968b8116c2edc2f1_17307218948d40b897c70f997f3f8197_12_SOVEREIGN_DECREES_EN.pdf`,
    `${A}/69e7126250fe4edcbb1b3d8628bb1e96_eacf522c47e947efba5abd8ef3382d94_SOVEREIGN_WORKBOOK_EN.pdf`,
    `${A}/42bf226c626a4afeb4e297dd2152dae3_611e2ee97b2149cf890cb35699f2ec5e_TRIPLE_FUSION_GRID_EN.pdf`,
    `${A}/ee574193963a4fa7ac4a6cdb1b603168_26658598fb974525bb72628748c5fc38_LO_SHU_DIRECTIONS_MAP_EN.pdf`,
    `${A}/703c4a883ba74f34a31a47defd48db41_FOUNDERS_LETTER_EN.pdf`,
  ],
  es: [
    `${A}/480953ca9b9a464d839c64a39b8494fa_ANTES_DE_QUE_TE_CONVIERTAS_ES_v1.pdf`,
    `${A}/790c16a6188045608d84cb5104b3579b_12_DECRETOS_SOBERANOS_ES.pdf`,
    `${A}/d2990047af824ca78ec1bbfd89106439_03dc3e3455254fec9522f6ed71a42287_CUADERNO_SOBERANO_ES.pdf`,
    `${A}/feb122e1cc01488daf83cc8575d56eb3_TRIPLE_FUSION_CUADRICULA_ES.pdf`,
    `${A}/99846ea15d2b46519eb027d417663a83_MAPA_DIRECCIONES_LO_SHU_ES.pdf`,
    `${A}/ccb2222fff234ccaadd179105f3fa8c4_1f80194cf43941ec8042486501fb0175_CARTA_FUNDADOR_ES.pdf`,
  ],
  pt: [
    `${A}/1e3510b4699d4b638d5222ddd515806f_ANTES_QUE_TE_TORNES_PT_v1.pdf`,
    `${A}/f3f3dc811fdc407b9f3b6be4582ed550_cdc2925bb1084cb78aa77cf7db6e0343_12_DECRETOS_SOBERANOS_PT.pdf`,
    `${A}/df72eec2138d4e9c97a3318f0d768d7c_ee4054c502dd45f583c1391570b3b035_CADERNO_SOBERANO_PT.pdf`,
    `${A}/fc1855c9f04e4f5d8716c7028682c633_TRIPLE_FUSION_GRELHA_PT.pdf`,
    `${A}/6a93870e32164bd1ad19058ccaeaf6d4_MAPA_DIRECOES_LO_SHU_PT.pdf`,
    `${A}/046d6722962f4020854dce114ac82e52_504e115315964608b245604ecd3c742f_CARTA_FUNDADOR_PT.pdf`,
  ],
};
